import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import Home from "./Components/home/Home";
import Onboarding from "./Components/onboarding/Onboarding";
import Topbar from "./Components/topbar/TopBar";
import LandingPage from "./Components/landing/LandingPage";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "./App.css";

function isOnboardingComplete(userSub) {
  try {
    return !!localStorage.getItem(`onboarding_${userSub}`);
  } catch {
    return false;
  }
}

// Wraps a route: authenticated users who haven't onboarded go to /onboarding first.
function ProtectedRoute({ children }) {
  const { isAuthenticated, isLoading, user } = useAuth0();
  if (isLoading) return null;
  if (!isAuthenticated) return children;
  if (!isOnboardingComplete(user.sub)) return <Navigate to="/onboarding" replace />;
  return children;
}

function App() {
  const { isAuthenticated, isLoading } = useAuth0();
  const [showBanner, setShowBanner] = useState(true);
  const [resultsMode, setResultsMode] = useState(false);

  // Show nothing while Auth0 checks session — avoids flash of landing page for returning users
  if (isLoading) return null;

  // Unauthenticated users see the landing page, but /demo bypasses login
  if (!isAuthenticated) {
    return (
      <Router>
        <Routes>
          <Route path="/demo" element={
            <div className={`app${showBanner ? ' has-banner' : ''}${resultsMode ? ' results-mode' : ''}`}>
              <Topbar showBanner={showBanner} onCloseBanner={() => setShowBanner(false)} resultsMode={resultsMode} />
              <Home onHideBanner={() => setShowBanner(false)} onResultsMode={() => setResultsMode(true)} />
            </div>
          } />
          <Route path="*" element={<LandingPage />} />
        </Routes>
      </Router>
    );
  }

  return (
    <Router>
      <div className={`app${showBanner ? ' has-banner' : ''}${resultsMode ? ' results-mode' : ''}`}>
        <Topbar showBanner={showBanner} onCloseBanner={() => setShowBanner(false)} resultsMode={resultsMode} />
        <Routes>
          <Route path="/" element={<ProtectedRoute><Home onHideBanner={() => setShowBanner(false)} onResultsMode={() => setResultsMode(true)} /></ProtectedRoute>} />
          <Route path="/landing" element={<LandingPage />} />
          {/* Login/Signup now live in the sidebar — redirect old routes */}
          <Route path="/login" element={<Navigate to="/" replace />} />
          <Route path="/signup" element={<Navigate to="/" replace />} />
          <Route path="/onboarding" element={<Onboarding />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
